<template>
  <b-row>
    <ThankYouModal />
    <Modal />
    <b-col class="col-lg-6 offset-lg-3 col-sm-12" v-if="!this.$store.state.loading">
      <div v-if="this.$store.state.noDataFound">
        <p class="text-left lead">
          We are sorry to inform you that with the information you have entered we were not able to locate any corresponding data within our system. Please verify that you have entered your information correctly.
          <br><br>
        </p>
      </div>
      <div v-if="!this.$store.state.noDataFound">
        <p class="text-center lead">
          Hello {{ this.$store.state.pii.first_name }}, we've found your information. <br> <b>Please choose one of the options below</b>.
        </p>

        <div class="view-wrapper">
          <b-button
            type="submit"
            variant="primary"
            class="btn btn-lg"
            v-on:click="requestInformation"
          >
            Request to view / download my information
          </b-button>
          <br><br>
        </div>

        <div class="dnc-wrapper">
          <b-button
            type="submit"
            variant="primary"
            class="btn btn-lg"
            v-on:click="requestDNC"
            :disabled="this.$store.state.requestDncCompleted"
          >
            Request do not sell / opt-out
          </b-button>
          <br><br>
        </div>

        <div class="delete-wrapper">
          <b-button
            type="submit"
            variant="primary"
            class="btn btn-lg"
            v-on:click="requestDeleteMethod"
            :disabled="this.$store.state.requestDeleteCompleted"
          >
           Request to delete my information
          </b-button>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
/* eslint-disable new-cap */
import Modal from '@/components/Modal.vue'
import ThankYouModal from '@/components/ThankYouModal'
import { mapState } from 'vuex'

export default {
  created: function () {
    this.isLoggedInMethod()
  },
  computed: mapState([
    'isLoggedIn', 'showModal', 'modalText', 'dncRequest', 'dncRequest', 'showThankYouModal'
  ]),
  methods: {
    isLoggedInMethod () {
      this.$store.dispatch('getLead')
    },
    requestDNC () {
      this.$store.dispatch('dncRequest')
    },
    requestInformation () {
      if (this.$store.state.lmsData === '') {
        this.$store.dispatch('getLead')
      } else {
        this.$bvModal.msgBoxConfirm('This message is verification that by clicking the “Continue” button we have (a) received your request for Disclosure “Right to know.” In addition, by clicking the “Continue” button we have processed your disclosure request as your information will be displayed on the next page.', {
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Continue',
          footerClass: 'p-2',
          hideHeaderClose: false
        }).then(value => {
          if (value === true) {
            this.$store.dispatch('redirectToInfoView')
          } else {
            // Do nothing
          }
        }).catch(err => {
          console.log('error: ', err) // Need to display an error message.
          return false
        })
      }
    },
    requestDeleteMethod () {
      this.$bvModal.msgBoxConfirm('Please confirm that you want to have your information deleted from our system. This action cannot be undone.', {
        title: 'Please Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false
      }).then(value => {
        if (value === true) {
          this.$store.dispatch('requestDelete')
        } else {
          // Do nothing
        }
      }).catch(err => {
        console.log('error: ', err) // Need to display an error message.
        return false
      })
    }
  },
  components: {
    ThankYouModal,
    Modal
  }
}
</script>
<style lang="less">
  #lmsData {
    min-height: 700px;
    font-family: "Lucida Console", Monaco, monospace;
    font-size: 0.8rem;
    line-height: 1.6;
  }
  #dnc-info, #dns-info {
    margin-left: 10px;
  }
  .icon-left {
    margin-right: 10px; // THIS IS A HACK, MY OCD CAN'T HANDLE THE ALIGNMENT
  }
</style>
